import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { CredusText } from 'ui';

import { SuccessIcon } from '../../../../../assets/images/svgs';
import { ReviewUploadProps } from '../ReviewUpload';

interface UploadSuccessProps extends ReviewUploadProps {
  showSuccess: boolean;
  setShowSuccess: React.Dispatch<React.SetStateAction<boolean>>;
}

const UploadSuccess = ({
  showSuccess,
  setShowSuccess,

  setReviewUpload,
}: UploadSuccessProps) => {
  const handleCancel = () => {
    setShowSuccess(false);
    setReviewUpload(false);
  };
  return (
    <Modal title="" open={showSuccess} footer="" onCancel={handleCancel}>
      <Container>
        <SuccessIcon />
        <CredusText size="xl" weight="medium">
          Success!
        </CredusText>
        <CredusText size="md" weight="regular">
          Candidates have been uploaded successfully
        </CredusText>
      </Container>
    </Modal>
  );
};

export default UploadSuccess;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 4rem 2rem;
`;
